import { Box, FormControl, TextField } from "@mui/material";
import AppoinmentModal from "../features/appoinment/appoinmentModal";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { getItems } from "../features/items_services/itemApi";


export const ChooseSelect = ({ dataprop, setDatat }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (setDatat) {
      setDatat(data)

    }
  }, [data])
  useEffect(() => {
    if (dataprop) {
      setData(dataprop)
    }

  }, [dataprop])
  return (
    <>
      <FormControl fullWidth sx={{ marginY: "5px" }}>
        {/* <InputLabel id="tags-label" className='mulish'>Services</InputLabel> */}
        <TextField
          size="small"
          onClick={() => {
            setOpen(true);
          }}
          aria-readonly={true}
          value={
            data.length > 0
              ? (function () {
                  let datat = [...data];
                  let val = "";
                  data.forEach((ele, index) => {
                    val += ele.service + " ,";
                  });
                  return val;
                })()
              : "Add Service"
          }
          InputProps={{
            sx: {
              color: "#545454",
              fontWeight: 400,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              paddingX: "7px",
            },
            endAdornment: (
              <AddIcon
                sx={{
                  display: {
                    xs: "block",
                    lg: "block",
                  },
                  cursor: "pointer",
                  color: (theme) => theme.palette.primary.main,
                }}
                onClick={() => {
                  setOpen(true);
                }}
              />
            ),
          }}
        />
      </FormControl>
      <AppoinmentModal
        open={open}
        setOpen={setOpen}
        data={data}
        setData={setData}
      />
    </>
  );
}